import { Component, OnInit, inject } from '@angular/core';
import { FormControl } from '@angular/forms';
import { AdminService } from '../../../admin/admin.service';
import {
  distinctUntilChanged,
  map,
  switchMap,
  startWith,
  debounceTime,
} from 'rxjs/operators';
import { ReportingService } from '../../reporting.service';
import { DateTime } from 'luxon';

@Component({
  selector: 'app-sales-tracking',
  templateUrl: './sales-tracking.component.html',
  styleUrls: ['./sales-tracking.component.scss'],
  standalone: false,
})
export class SalesTrackingComponent implements OnInit {
  private admnSvc = inject(AdminService);
  private rptSvc = inject(ReportingService);

  unitsControl = new FormControl();

  selectedUnit;
  sales = {
    unit: null,
    user: null,
    at: 'ALL',
    st: 'ALL',
    ri: 'ALL',
    gap: 720,
    startDate: null,
    endDate: null,
  };
  filteredUnits;
  activityTypes = ['ALL', 'BA', 'LK'];
  saleTypes = ['ALL', 'LI', 'IN', 'OP', 'AN', 'IV'];
  repIntersectTypes = ['ALL', 'True', 'False'];
  salesTrackingData = { data: null, headers: null };

  ngOnInit(): void {
    this.getUnits();
  }

  getSalesTracking() {
    this.rptSvc.getSalesTracking(this.sales).subscribe({
      next: data => {
        this.salesTrackingData = { ...data.results };
      },
      error: error => {
        console.error(error);
      },
    });
  }

  checkSelection() {
    if (
      !this.filteredUnits ||
      !this.filteredUnits.find(unit => {
        return unit.id === this.unitsControl.value;
      })
    ) {
      this.unitsControl.setValue(null);
    }
  }

  getUnits() {
    this.unitsControl.valueChanges
      .pipe(debounceTime(500), distinctUntilChanged())
      .subscribe(value => {
        if (value) {
          this.admnSvc.getUnitList(value, true).subscribe(resp => {
            if (resp['names']) {
              this.filteredUnits = resp['names'];
            }
          });
        }
      });
  }

  changeDate(ev) {
    if (ev.targetElement.className.includes('start-date')) {
      this.sales.startDate = DateTime.fromJSDate(new Date(ev.value))
        .startOf('day')
        .toUTC()
        .toISO();
    } else if (ev.targetElement.className.includes('end-date')) {
      this.sales.endDate = DateTime.fromJSDate(new Date(ev.value))
        .endOf('day')
        .toUTC()
        .toISO();
    }
  }
}
